//GeneratorFlag:[NoChange]
import Warehouse from './warehouse';

export default {Warehouse}
export{Warehouse}